import { I as InternalEventType } from './internal-event-types-8598fbfb.js';

class InternalDropdownValueSelectedEvent {
  constructor(value) {
    this.TYPE = InternalEventType.INTERNAL_DROPDOWN_VALUE_SELECTED_EVENT;
    this.payload = { value };
  }
}

export { InternalDropdownValueSelectedEvent as I };
